export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_FAIL = 'REGISTER_FAIL'

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAIL = 'LOGIN_FAIL'
export const LOGOUT = 'LOGOUT'

export const USER_LOADED = 'USER_LOADED'
export const AUTH_ERROR = 'AUTH_ERROR'

export const PROFILE_LOADED = 'PROFILE_LOADED'
export const PROFILE_LOADED_FAIL = 'PROFILE_LOADED_FAIL'

export const PROFILE_UPDATED_SUCCESS = 'PROFILE_UPDATED_SUCCESS'
export const PROFILE_UPDATED_FAIL = 'PROFILE_UPDATED_FAIL'
